module.exports = [{"type":"title","text":"2025-06-17"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"USDT-M Perp Futures: Websocket ‘Market Depth Data’ push intervals adjusted to 200ms and 500ms."}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2025-06-17.json
// module id = XMQV
// module chunks = 3